const { createAct } = require('coact/utils/action')

module.exports = createAct({
  namespace: ['lisheng', 'StockState'],
  types: ['findStocks', 'download'],
})
